import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

import face  from '../../../assets/img/faces/muestra.jpg';


class InfoCarrera extends Component {
    state = {  }
    render() { 
        return (
            <Row style={{backgroundColor: "f4f4f4", paddingLeft: "10%", paddingRight: "10%", paddingBottom: 40}}>
                <Col md={5} style={{marginTop: 40}}>
                    <div style={{backgroundColor: "FFF", borderRadius: "4px 4px", border: "1px solid #d6d6d6", padding: "10%"}}>
                        <div align="center"><img src={face} alt="" className="img-responsive"/></div>
                        <div className="custom-mt-10 text-muted fuente-monserrat" style={{fontSize: 20}} align="center">
                            Publicidad y Mercadeo
                        </div>
                        <div className="fuente-monserrat custom-mt-10" align="center"><strong>Titulo a Obtener:</strong> Nombre del Título</div>
                        <div className="fuente-monserrat custom-mt-10" align="center"><strong>Director:</strong> Nombre del Director</div>
                        <div className="fuente-monserrat custom-mt-10" align="center"><strong>Correo Electrónico:</strong> Correo</div>
                        <div className="fuente-monserrat custom-mt-10" align="center"><strong>Teléfonos:</strong> 0123456678</div>
                    </div>
                </Col>
                <Col md={7} style={{marginTop: 40, paddingLeft: "5%", paddingRight: "5%"}}>
                    <h3 className="fuente-monserrat" style={{color:"a80012"}}>Publicidad y Mercadeo</h3>
                    <div align="justify" className="fuente-monserrat custom-mt-20">
                        La carrera de Publicidad y Mercadeo forma profesionales capacitados para diseñar, crear y aplicar a través de las herramientas del mercadeo y la publicidad, estrategias de crecimiento y comunicación innovadoras y acordes con los tiempos actuales, orientadas a aportar al desarrollo integral de una empresa o institución, y así satisfacer las necesidades del mercado. 
                    </div>
                </Col>
            </Row>
        );
    }
}
 
export default InfoCarrera;


// WEBPACK FOOTER //
// ./src/site/Componentes/PublicidadMercadeo/InfoCarrera.jsx